// libraries
import { hostUrlHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';

export const getQueryParamByName = (name: string): string | null => {
    const docLocHref = locHrefUtil.getLocHref();
    return hostUrlHelper.getQueryParamFromDocLocHref(docLocHref, name);
};
